<template>
  <div class="doorpost-banner">
    <img :src="doorpostBanner" alt="" />
    <div class="absolute">
      <div class="title">无人门岗</div>
      <div class="text">
        一种通道管理方式，出入口均采用自动放行方式，或者车主自助放行方式，实现出入口无人化管理。
      </div>
      <div class="experience" @click="experienceClick">立即体验</div>
    </div>
  </div>
  <Experience
    v-if="experienceShow"
    :experienceShow="experienceShow"
    @experienceClick="experienceClick"
  ></Experience>
</template>

<script>
import { reactive } from "vue";

import Experience from "../../../../components/pc/components/Experience.vue";

import doorpostBanner from "../../../../assets/programme/doorpostBanner.png";

export default {
  setup() {
    return reactive({
      doorpostBanner: doorpostBanner,
      experienceShow: false,
    });
  },
  components: {
    Experience,
  },
  methods: {
    experienceClick() {
      this.experienceShow = !this.experienceShow;
    },
  },
};
</script>

<style scoped>
.doorpost-banner {
  position: relative;
}
@media screen and (max-width: 1180px) {
  .doorpost-banner {
    min-width: 1180px;
  }
}
.doorpost-banner img {
  width: 100%;
  height: 368px;
}
.absolute {
  position: absolute;
  top: 50%;
  left: 36%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 40px;
}
.absolute .title {
  font-size: 30px;
  color: #248efb;
}
.absolute .text {
  width: 540px;
  font-size: 14px;
  margin-top: 20px;
  color: #248efb;
}
.absolute .experience {
  margin-top: 60px;
  font-size: 16px;
  color: #248efb;
  width: 108px;
  height: 36px;
  line-height: 36px;
  border: 1px solid #248efb;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  cursor: pointer;
}
</style>
